window.utils = (function ($) {
  function isElementInViewport(el) {
    // special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    if (typeof (el) == 'undefined' || !el) return;
    var rect = el.getBoundingClientRect();
    var clientHeight = (window.innerHeight || document.documentElement.clientHeight);
    return (
      (rect.top <= 0
       && rect.bottom >= 0)
      ||
      (rect.bottom >= clientHeight &&
       rect.top <= clientHeight)
      ||
      (rect.top >= 0 &&
       rect.bottom <= clientHeight)
    );
  }

  return {
    isElementInViewport: isElementInViewport
  }
}(jQuery));